<script setup lang="ts">
import colorRating from '~/components/ui/colorRatingAtom/colorRatingAtom.vue';
import type { ModelShopInfo } from '~/interfaces/api';
import { numberTitles } from '~/common/const';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useTimeCalculation } from '~/composition/useTimeCalculation';

const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  modelPath: {
    type: String,
    required: true,
  },
  model: {
    type: Object as () => ModelShopInfo,
    required: true,
  },
  isTile: {
    type: Boolean,
    default: false,
  },
});
const mediaStore = useMediaQueryStore();
const isMobile = computed(() => mediaStore.isEs || mediaStore.isSm);
const modelRating = computed(() => {
  return Number((props.model.rating / 20).toFixed(1)) > 0
    ? (props.model.rating / 20).toFixed(1)
    : null;
});
useTimeCalculation();
</script>

<template>
  <div :class="['rating-merchant', { 'hide-count': isTile && isMobile }]">
    <colorRating
      :class="{'rating-merchant__rating': model.review_count}"
      :rating="rating"
      :model-rating="modelRating"
    />
    <nuxt-link
      v-if="modelRating || model.review_count"
      class="rating-merchant__reviews body-m-regular"
      :to="model.review_count ? `/${model.slug}/otzyvy/` : modelPath"
      @click.stop
    >
      <span v-if="model.review_count">
        {{ model.review_count }}
        {{
          numberTitles(model.review_count, ['отзыв', 'отзыва', 'отзывов'])
        }}</span
      >
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.rating-merchant {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;

  bottom: 4px;
  @include md-block {
    border-radius: 3px 3px 0 0;
    background: $white;
  }

  &__rating {
    margin-right: 6px;
  }

  &__reviews {
    color: #86888f;
  }

  &.hide-count {
    .rating-merchant__reviews {
      display: none;
    }
  }
}
</style>
